import InvoicingOwnerModel    from 'Models/invoice/InvoicingOwnerModel';
import OwnerSubPartitionModel from 'Models/invoice/OwnerSubPartitionModel';
import doc                    from 'decorators/doc';
import model                  from 'decorators/model';
import { Timestampable }      from 'helpers/traits';
import { Blamable }           from 'helpers/traits';
import InvoicePrivateApiModel from 'modelx/models/abstracts/InvoicePrivateApiModel';
import InvoicingGroupModel    from './InvoicingGroupModel';

@model.staticLabel('InvoicingOwnerSubPartition')
@model.urnResource('invoicing_owner_sub_partition')
@doc.path('/invoicing_owner_sub_partitions/{?id}')
export default class InvoicingOwnerSubPartitionModel extends Blamable(Timestampable(InvoicePrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'defaultInvoicingGroup': id;
		'invoicingOwner': id;
		'invoicingOwner.enterpriseUrn': Urn;
		'ownerSubPartition': id;
		'ownerSubPartition.partitionUrn': Urn;
		'ownerSubPartition.subPartitionUrn': Urn;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
	}> = {};

	@doc.model(InvoicingGroupModel) declare defaultInvoicingGroup: InvoicingGroupModel;
	@doc.model(InvoicingOwnerModel) declare invoicingOwner: InvoicingOwnerModel;
	@doc.model(OwnerSubPartitionModel) declare ownerSubPartition: OwnerSubPartitionModel;
}
